import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Spinner } from './ui';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Spinner />;
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (user.needsProfile && location.pathname !== '/complete-profile') {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/complete-profile?next=${next}`} replace />;
  }
  return <>{children}</>;
}

export function RequireStaff({ children }: { children: ReactNode }) {
  const { user, loading, isLeagueStaff } = useAuth();
  const location = useLocation();
  if (loading) return <Spinner />;
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (user.needsProfile && location.pathname !== '/complete-profile') {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/complete-profile?next=${next}`} replace />;
  }
  if (!isLeagueStaff) return <Navigate to="/" replace />;
  return <>{children}</>;
}
